import { Group, Tween } from "@tweenjs/tween.js";
import * as PIXI from "pixi.js";

export function configCheckerHighlight(
  texture: PIXI.Texture,
  position: { x: number; y: number },
  boardScale: number
): { sprite: PIXI.Sprite; group: Group } {
  const sprite = new PIXI.Sprite(texture);
  sprite.anchor.set(0.5, 0.5);
  sprite.position.set(position.x, position.y);
  sprite.scale.set(boardScale, boardScale);
  sprite.roundPixels = true;

  // Tween: fade in
  const alphaTween = new Tween({ alpha: 0 })
    .to({ alpha: 1 }, 500)
    .onUpdate((values: { alpha: number }) => {
      sprite.alpha = values.alpha;
    });
  // Tween: rotate indefinitely
  const rotationTween = new Tween({ rotation: 0 })
    .to({ rotation: Math.PI }, 750)
    .repeat(Infinity)
    .onUpdate((values: { rotation: number }) => {
      sprite.rotation = values.rotation;
    });

  const group = new Group();
  group.add(alphaTween);
  group.add(rotationTween);

  return { sprite, group };
}

export function configAreaTargetHighlight(
  texture: PIXI.Texture,
  position: { x: number; y: number },
  rotation: number,
  boardScale: number
): { sprite: PIXI.Sprite; tween: Tween } {
  const sprite = new PIXI.Sprite(texture);
  sprite.anchor.set(0.5, 0);
  sprite.position.set(position.x, position.y);
  sprite.scale.set(boardScale, boardScale);
  sprite.rotation = rotation;
  sprite.roundPixels = true;
  sprite.alpha = 0;

  // Tween: ping-pong alpha between 0 and 1
  const tween = new Tween({ alpha: 0 })
    .to({ alpha: 1 }, 750)
    .yoyo(true)
    .repeat(Infinity)
    .onUpdate((values: { alpha: number }) => {
      // HACK - workaround for a bug with Tween.js specifically with the yoyo repeat mode.
      // https://github.com/tweenjs/tween.js/issues/677
      if (Math.abs(sprite.alpha - values.alpha) < 0.25) {
        sprite.alpha = values.alpha;
      }
    });

  return { sprite, tween };
}
